import dayjs from 'dayjs';

// Helper function for week of month calculation
export const getWeekOfMonthStr = (date: dayjs.Dayjs) => {
  const weekOfMonth = date.week() - date.startOf('month').week() + 1;
  return weekOfMonth === 1
    ? '1st'
    : weekOfMonth === 2
      ? '2nd'
      : weekOfMonth === 3
        ? '3rd'
        : `${weekOfMonth}th`;
};

export const getRiskLevel = (dca: number) => {
  if (dca < 1) {
    return { level: 'High', className: 'critical', color: '#dc2626' };
  }
  if (dca < 5) {
    return { level: 'Medium', className: 'high', color: '#e08600' };
  }
  return { level: 'Low', className: 'low', color: '#51c033' };
};

// Filter conjunctions by risk level
export const filterConjunctionsByRisk = (
  data: any[],
  activeRiskFilter: string
) => {
  switch (activeRiskFilter) {
    case 'High':
      return data.filter(item => item.dca < 1);
    case 'Medium':
      return data.filter(item => item.dca >= 1 && item.dca < 5);
    case 'Low':
      return data.filter(item => item.dca >= 5 && item.dca <= 10);
    default:
      return data;
  }
};

// Format trend display
export const formatTrendDisplay = (trend: number | null) => {
  if (trend === null) return null;

  if (trend === 0) {
    return {
      text: 'No change from yesterday',
      arrow: '●',
      className: 'trend-neutral',
    };
  }

  const absValue = Math.abs(trend);
  const direction = trend > 0 ? 'more' : 'less';
  const arrow = trend > 0 ? '▲' : '▼';
  const className = trend > 0 ? 'trend-up' : 'trend-down';

  return {
    text: `${absValue.toLocaleString()} ${direction} than yesterday`,
    arrow,
    className,
  };
};
